module.exports = __webpack_public_path__ + "static/media/attached.46be346e.svg";